import { render, staticRenderFns } from "./lafia_castle.vue?vue&type=template&id=e10ed560"
import script from "./lafia_castle.vue?vue&type=script&lang=js"
export * from "./lafia_castle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports